import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import type { Option } from "../../types";
import { SingleAutocomplete } from "../../shared/SingleAutocomplete";
import { inlineInputStateStyles } from "./InlineInputState";

type SingleSelectProps = InputProps<string> & {
  options: Option[];
};

export const SingleSelect: FC<SingleSelectProps> = ({ options, ...props }) => {
  return (
    <SingleAutocomplete
      {...props}
      inlineInputStateStyles={inlineInputStateStyles}
      options={options}
      noOptionsTextKey="DynamicForm.Option.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
      chipVariant="choice"
    />
  );
};
